import { Injectable, OnDestroy } from "@angular/core";
import { Subject } from "rxjs/internal/Subject";

@Injectable()

export class HandleSubscription implements OnDestroy {
    unsubscribe$ = new Subject<void>();

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
